export default [
    {
        id: 7,
        image: 'images/tours/ra-search.png',
        title: 'tours.ra-search.title',
        tour: 'ra-search',
        comment: 'tours.ra-search.comment',
        href: 'http://marmelab.com/react-admin',
    },
    {
        id: 6,
        image: 'images/tours/ra-navigation-breadcrumb.jpg',
        title: 'tours.ra-navigation-breadcrumb.title',
        tour: 'ra-navigation-breadcrumb',
        comment: 'tours.ra-navigation-breadcrumb.comment',
        href: 'http://marmelab.com/react-admin',
    },
    {
        id: 4,
        image: 'images/tours/ra-realtime.jpg',
        title: 'tours.ra-realtime.title',
        tour: 'ra-realtime',
        comment: 'tours.ra-realtime.comment',
        href: 'http://marmelab.com/react-admin',
    },
    {
        id: 5,
        image: 'images/tours/ra-editable-datagrid.jpg',
        title: 'tours.ra-editable-datagrid.title',
        tour: 'ra-editable-datagrid',
        comment: 'tours.ra-editable-datagrid.comment',
        href: 'http://marmelab.com/react-admin',
    },
    {
        id: 3,
        image: 'images/tours/ra-tree.jpg',
        title: 'tours.ra-tree.title',
        tour: 'ra-tree',
        comment: 'tours.ra-tree.comment',
        href: 'http://marmelab.com/react-admin',
    },
    {
        id: 1,
        image: 'images/tours/ra-markdown.jpg',
        title: 'tours.ra-markdown.title',
        tour: 'ra-markdown',
        comment: 'tours.ra-markdown.comment',
        href: 'http://marmelab.com/react-admin',
    },
];
